export const FETCH_TASKS_REQUEST = 'FETCH_TASKS_REQUEST';
export const FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';
export const FETCH_TASKS_FAILED = 'FETCH_TASKS_FAILED';

export const FETCH_CREATE_TASK_REQUEST = 'FETCH_CREATE_TASK_REQUEST';
export const FETCH_CREATE_TASK_SUCCESS = 'FETCH_CREATE_TASK_SUCCESS';
export const FETCH_CREATE_TASK_FAILED = 'FETCH_CREATE_TASK_FAILED';

export const FETCH_TASK_BY_ID_REQUEST = 'FETCH_TASK_BY_ID_REQUEST';
export const FETCH_TASK_BY_ID_SUCCESS = 'FETCH_TASK_BY_ID_SUCCESS';
export const FETCH_TASK_BY_ID_FAILED = 'FETCH_TASK_BY_ID_FAILED';

export const FETCH_UPDATE_TASK_REQUEST = 'FETCH_UPDATE_TASK_REQUEST';
export const FETCH_UPDATE_TASK_SUCCESS = 'FETCH_UPDATE_TASK_SUCCESS';
export const FETCH_UPDATE_TASK_FAILED = 'FETCH_UPDATE_TASK_FAILED';
export const RESET_CURRENT_TASK = 'RESET_CURRENT_TASK';
